import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash-es';
import { sagaActions } from '../../../../../../../../sagas/sagaActions';
import { AppConstant } from '../../../../../../../Assests/AppConstant';
import { getCurrentDate } from '../../../../../../../../Utils/DateUtils';
import { initiateSearch, showAlert, changeFormatWithoutTz } from '../../../../../../../Assests/Utility';
import { toast } from 'react-toastify';
import { getUserSelector } from '../../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { getWhMetaDataReducerSlice } from '../../../../../../../../redux/reducers/reducerSlices/WhMetaDataReducerSlice';
import moment from 'moment';
import './BreakConflictForm.css';

import DrilldownTableSS from '../../../../../Components/Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTableSS';
import CustomButtonSS from '../../../../../../Common/CustomButton/CustomButtonSS';
import SSPopup from '../../../../../../Common/Popup/SSPopup/SSPopup';

const BreakConflictFormSS = (props) => {

    const { themeSelected, dockPayload } = props;
    const dispatch = useDispatch();
    const whMetaReducer = useSelector(getWhMetaDataReducerSlice);
    const { operationObj, arrangeOrder, arrangeKey, dockConflictObj } = whMetaReducer;
    const [isListLoading, setListLoading] = useState(false);
    const [metaTimeslotArr, setMetaTimeslotArr] = useState([]);
    const [dockDoorConflictArr, setdockDoorConflictArr] = useState([]);
    const user = useSelector(getUserSelector);
    const { cu_id } = user;
    const [currentItemIndex, setCurrentItemIndex] = useState('NA');
    const [currentDeleteIndex, setCurrentDeleteIndex] = useState('NA');
    const [selectedObj, setSelectedObj] = useState(null)
    const [selectedIndex, setSelectedIndex] = useState(null)
    const [showDeleteModel, setShowDeleteModel] = useState(false);
    const [showLoading, setShowLoading] = useState(true);


    const dockBreaksTitleDD = [
        { id: '', name: AppConstant.superUserAdmin.companyGroup.tableHeader.serialNum },
        { id: 'Description', name: AppConstant.smartScheduler.docksTimeSlots.tableHeaders.description },
        { id: 'BreakStart', name: AppConstant.smartScheduler.breaksForm.tableHeaders.fromTitle },
        { id: 'BreakEnd', name: AppConstant.smartScheduler.breaksForm.tableHeaders.tillTitle },
        { id: 'CreatedOn', name: AppConstant.superUserAdmin.companyGroup.tableHeader.createdOn },
        { id: 'status', name: AppConstant.superUserAdmin.companyGroup.tableHeader.status },
        { id: '', name: AppConstant.superUserAdmin.warehouseAdmin.warehouseTable.actionsColTitle },
    ]

    useEffect(() => {
        if (dockConflictObj && dockConflictObj.breaks.length) {
            setShowLoading(false);
            setdockDoorConflictArr(dockConflictObj.breaks)
        } else {
            setdockDoorConflictArr([])
            setShowLoading(false)
        }

    }, [dockConflictObj.breaks])

    /**
     * handle the API response
     */
    useEffect(() => {
        if (operationObj.type) {
            switch (operationObj.type) {
                case 'Delete Breaks':
                    if (operationObj.status) {
                        handleApiResponse(AppConstant.notifications.dataAddedSuccess, AppConstant.smartScheduler.breaksForm.deleteBreakSuccess);
                    } else {
                        handleApiResponse(AppConstant.commonStrings.failure, AppConstant.smartScheduler.breaksForm.deleteBreakFailure);
                    }
                    break;
                default:
            }
        }
    }, [operationObj])


    /**
     * Handle API response base on success and failure
     * @param {*} result 
     * @param {*} message 
     */
    const handleApiResponse = (result, message) => {
        setCurrentItemIndex('NA')
        setCurrentDeleteIndex('NA')
        if (result === AppConstant.notifications.dataAddedSuccess) {
            showAlert(toast.TYPE.SUCCESS, message, themeSelected);
            dispatchDockConflict()
        } else {
            showAlert(toast.TYPE.ERROR, message, themeSelected);
        }
        setListLoading(false);
        dispatch({ type: sagaActions.RESET_OPERATION_OBJECT_WH });
    }

    const dispatchDockConflict = () => {
        dispatch({ type: sagaActions.GET_DOCK_CONFLICT_DETAILS, payload: dockPayload });
    }

    const deleteHandler = (data, index) => {
        setSelectedObj(data)
        setSelectedIndex(index)
        setShowDeleteModel(true)
    }
    /**
     * used to handle API call 
     * @param {*} text 
     */
    const popupBtnHandler = (text) => {
        if (text === AppConstant.commonStrings.no) {
            setShowDeleteModel(false)
            setSelectedObj(null)
            setSelectedIndex(null)
        }
        else {
            setCurrentDeleteIndex(selectedIndex)
            const apiParams = {
                "IDDockBreak": selectedObj.IDDockBreak,
                // "IDWHBreak": currentFilterSelected.name === "Warehouse" ? selectedObj.IDWHBreak : null,
                "IDWarehouse": selectedObj.IDWarehouse,
                "BreakStart": selectedObj.BreakStart,
                "BreakEnd": selectedObj.BreakEnd,
                "Description": selectedObj.Description,
                "Status": true,
                "CreatedBy": cu_id,
                "CRUDTYPE": "D",
                "UpdatedBy": cu_id,
                "CreatedOn": selectedObj.CreatedOn,
                "UpdatedOn": changeFormatWithoutTz(getCurrentDate(), AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                "IDDock": selectedObj.IDDock,
            }

            const operationObj = {
                type: 'Delete Breaks',
                status: ''
            }

            dispatch({ type: sagaActions.WAREHOUSE_META_DOCKS_BREAKS_LIST_ACTION, payload: apiParams, operationObj: operationObj })
        }
        setShowDeleteModel(false)
    }
    /**
     * used to create and show pop
     * @returns 
     */
    const showDeleteConfirmation = () => {
        const popupObj = {
            id: 'showDeleteConfirmation',
            modalLabel: 'showDeleteConfirmation',
            showClose: true,
            showfooter: true,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: AppConstant.smartScheduler.breaksForm.deleteBreakTitle,
            bodyText: `${AppConstant.commonStrings.areYouSure} ${AppConstant.smartScheduler.breaksForm.deleteBreakTitle}`,
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: {
                    show: true,
                    text: AppConstant.commonStrings.yes
                },
                btn2: {
                    show: true,
                    text: AppConstant.commonStrings.no
                }
            },
        }

        return <SSPopup {...popupObj} popupBtnHandler={(text) => { popupBtnHandler(text) }} closepopup={() => { setShowDeleteModel(false) }} themeSelected={themeSelected} showModal={showDeleteModel} />
    }

    /**
     * created custom buttons
     * @param {*} groupObj 
     * @param {*} index 
     * @returns 
     */

    const actionsButton = (groupObj, index) => {
        return (
            <div>
                <span className='d-flex justify-content-center align-items-center gap-2' >
                    <CustomButtonSS
                        disabled={false}
                        isLoading={currentDeleteIndex !== 'NA' && currentDeleteIndex === index ? true : false}
                        className={`no-border no-bg`}
                        onClick={() => { deleteHandler(groupObj, index) }}
                        isIcon={true}
                        iconClass={"fa-regular fa-trash-can fa-lg"}
                    />
                </span>
            </div>
        )
    }

    /**
     * format the data
     * @param {*} data 
     * @returns 
     */
    const formatListDataDrillDown = (data) => {
        return data.map((el, index) => {
            return {
                id: el.RoleID,
                0: index + 1,
                1: el.Description || AppConstant.commonStrings.hypen,
                2: changeFormatWithoutTz(el.BreakStart, AppConstant.commonStrings.HH_mm_dateFormat) || AppConstant.commonStrings.hypen,
                3: changeFormatWithoutTz(el.BreakEnd, AppConstant.commonStrings.HH_mm_dateFormat) || AppConstant.commonStrings.hypen,
                4: `${moment(el.CreatedOn).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)}\n${moment(el.CreatedOn).format(AppConstant.commonStrings.HH_mm_dateFormat)}` || AppConstant.commonStrings.hypen,
                5: el.Status ? 'Enabled' : 'Disabled',
                6: actionsButton(el, index),
            }
        })
    }

    return (
        <>
            {dockDoorConflictArr &&
                <DrilldownTableSS
                    themeSelected={themeSelected}
                    bodyData={dockDoorConflictArr.length && formatListDataDrillDown(dockDoorConflictArr)}
                    titleData={dockBreaksTitleDD}
                    showCollapse={false}
                    showInput={false}
                    showSort={true}
                    arrangeOrder={arrangeOrder}
                    arrangeKey={arrangeKey}
                    drillDownReport={dockDoorConflictArr}
                    initiateDrillDownReport={isListLoading}
                    loaderArray={6}
                    sortingAction={sagaActions.SORT_WH_META_TABLE_ACTION}
                    subRoot={{ pathName: 'whMetaTimeslotArr' }}
                    showUTCTime={false}
                />}
            {showDeleteConfirmation()}
        </>
    )

}

export default BreakConflictFormSS;